<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <cr-combine />
      </div>
    </div>
</section>
</template>

<script>
import crCombination from './Temp/CrCombinationTemp.vue'

export default {
  name: 'Tables',
  components: {
    'cr-combine': crCombination
  },
  methods: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CrCombination.vue?d424ff1e